import module from 'cheques/module.js'
import template from './template.html'

class ChequesAgregarComponent {
  constructor (ChequesEmpresas, ChequesProyectos, ChequeEmpleados, ChequesLeyendas, ChequesBeneficiarios, ChequesGastos, $catalogos, $q, $state, $api) {
    this.ChequesEmpresas = ChequesEmpresas
    this.ChequesProyectos = ChequesProyectos
    this.ChequeEmpleados = ChequeEmpleados
    this.ChequesLeyendas = ChequesLeyendas
    this.ChequesBeneficiarios = ChequesBeneficiarios
    this.ChequesGastos = ChequesGastos
    this.$catalogos = $catalogos
    this.$q = $q
    this.$state = $state
    this.$api = $api
    this.data = null
    this.onClose = null
    this.onEdit = null
    this.cuentasBancarias = null
    this.catalogos = {}
    this.imprimir = false
    this.guardando = false
  }

  $onInit () {
    this.data = this.data || {}
    this.data.status = this.data.status || 't'
    this.data.id_forma_pago = this.data.id_forma_pago || '02'

    this.$promise = this.$q.all([
      this.ChequesEmpresas.get()
        .then((response) => (this.operadoras = response.data)),
      this.ChequesProyectos.get()
        .then((response) => (this.proyectos = response.data)),
      this.ChequesLeyendas.get()
        .then((response) => (this.leyendas = response.data)),
      this.ChequesBeneficiarios.get()
        .then((response) => (this.beneficiarios = response.data)),
      this.$catalogos.get('cuentasBancarias')
        .then((data) => (this.cuentasBancarias = data)),
      this.$catalogos.get('gastoTipo')
        .then((data) => (this.catalogos.tipos = data.filter((item) => item.Descripcion !== 'Ninguno'))),
      this.$catalogos.get('gastoCategoria')
        .then((data) => (this.catalogos.categorias = data.filter((item) => item.Descripcion !== 'Ninguno'))),
      this.$catalogos.get('puestos')
        .then((data) => (this.catalogos.puestos = data)),
      this.$catalogos.get('proveedores')
        .then((data) => (this.catalogos.proveedores = data)),
      this.$catalogos.get('areasFinanzas')
        .then((data) => (this.catalogos.areasFinanzas = data)),
      this.$catalogos.get('sucursales')
        .then((data) => (this.catalogos.sucursales = data)),
    ])
      .then(() => {
        this.data.fecha_cheque = this.data.fecha_cheque || new Date()
        if (this.data.id_operadora) this.filtarCuentas()
        if (this.data.id_empresa) this.traerEmpleados()
      })
  }

  cancelar () {
    this.$state.go('^.listado')
  }

  traerEmpleados () {
    return this.ChequeEmpleados.get(this.data.id_empresa)
      .then((response) => (this.empleados = response.data))
  }

  filtarCuentas () {
    this.catalogos.cuentasbancarias = this.cuentasBancarias.filter((item) => item.ID_Cliente === this.data.id_operadora)
  }

  guardar () {
    if (this.guardando) return

    this.guardando = true

    this.ChequesGastos.post(this.data)
      .then((response) => {
        this.imprimir = true
        this.guardando = false
        this.link = this.$api.link('/api/empresa/banco/cuenta/impresion', {folio: response.data})
      })
  }

  editar () {
    if (this.guardando) return

    this.guardando = true

    return this.ChequesGastos.put(this.data)
      .then((response) => {
        this.guardando = false
        this.onEdit({$event: {data: response.data}})
      })
  }
}

module.component('chequesAgregar', {
  controller: ChequesAgregarComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
    onEdit: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cheques/components/agregar/component.js